import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray } from '@angular/forms';

interface FieldConfig {
  property: string;
  placeholder?: string;
}

@Component({
  selector: 'multi-item-input',
  templateUrl: './multi-item-input.component.html',
  styleUrls: ['./multi-item-input.component.scss']
})
export class MultiItemInputComponent {
  @Input() fields: FieldConfig[];
  @Input() formArray: FormArray;
  @Output() addItem = new EventEmitter();
  @Output() removeItem = new EventEmitter();
  @Output() openItem = new EventEmitter();
}
